import React from "react";

export default function Monitoring() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.35938 9.08333C5.35938 7.82918 6.37606 6.8125 7.6302 6.8125H18.2272C19.4815 6.8125 20.498 7.82918 20.498 9.08333V15.139C20.498 16.3931 19.4815 17.4098 18.2272 17.4098H7.6302C6.37606 17.4098 5.35938 16.3931 5.35938 15.139V9.08333Z"
                fill="#4F6E90"/>
            <path
                d="M8.8302 18.1667L7.85154 19.1454C7.6351 19.3618 7.57035 19.6874 7.68757 19.9704C7.80466 20.2532 8.08065 20.4376 8.38682 20.4376H17.4701C17.7763 20.4376 18.0523 20.2532 18.1695 19.9704C18.2866 19.6874 18.2218 19.3619 18.0054 19.1454L17.0267 18.1667H8.8302Z"
                fill="#354F6C"/>
        </svg>
    );
}
